import { authKeys } from './auth-keys';
import { inventoryKeys } from './inventory-keys';
import { settingsKeys } from './settings-keys';
import { tradesKeys } from './trades-keys';
import { counterpartyKeys } from './counterparty-keys';
import { recallReportKeys } from './recall-report-keys';
import { availabilityReportKeys } from './availability-report-keys';
import { fxRatesKeys } from './fx-rates-keys';
import { savedViewsKeys } from './saved-views-keys';
import { billingKeys } from './billing-keys';
import { cashPoolKeys } from './cash-pool-keys';

export const queryKeys = {
  auth: authKeys,
  inventory: inventoryKeys,
  settings: settingsKeys,
  trades: tradesKeys,
  counterparty: counterpartyKeys,
  recallReport: recallReportKeys,
  availabilityReport: availabilityReportKeys,
  fxRates: fxRatesKeys,
  savedViews: savedViewsKeys,
  billing: billingKeys,
  cashPool: cashPoolKeys,
} as const;

export {
  authKeys,
  inventoryKeys,
  settingsKeys,
  tradesKeys,
  counterpartyKeys,
  recallReportKeys,
  availabilityReportKeys,
  fxRatesKeys,
  savedViewsKeys,
  billingKeys,
  cashPoolKeys,
};
